(function() {
    'use strict';
a3_cabin_reports.factory('CrewAssessmentFactory', CrewAssessmentFactory);
                                                   
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name CrewAssessmentFactory
    * @description 
    *   Add, Update, Delete and Get Cabin Crew Feedback.
    * @ngInject
    */
function CrewAssessmentFactory(localStorageMD5Service, CrewAssessmentMemberFactory, FlightFactory, CrewAssessmentTemplateFactory, 
								CabinReportLocalEditFactory,GenericService, UserFactory, defaultCalendarDate) {

        /**
        * Initialize the CrewAssessment
        * @memberof CrewAssessmentFactory
        */
		function CrewAssessment() {
			this.Id = null;
			this.UserId = null;
			this.Route = null;
			this.DutyDate = null;
			this.DutyDay = null;
			this.AcType = null;
			this.Status = 'Pending';
			this.IsExist = false;
			this.assessedBy = [];
			this.CrewAssessmentMembers = [];
			this.Flights = [];
			this.GetId = GetId;
            this.start = null;
            this.end = null;
			this.FeedbackDate = null;
		}
				
		var objType = 'crewAssessments';
		var objCallback = CrewAssessment;  
				
		var service = 
		{  
			getCrewAssessmentsFromStorage : getCrewAssessmentsFromStorage,
			setCrewAssessmentsToStorage : setCrewAssessmentsToStorage,
			setCrewAssessmentToStorage : setCrewAssessmentToStorage,
			getCrewAssessmentFromStorage : getCrewAssessmentFromStorage,
			getCountOfUncompletedAssessments : getCountOfUncompletedAssessments,
			getCrewAssessmentByRouteAndDay : getCrewAssessmentByRouteAndDay,
			getCrewAssessmentByDutyNoAndDay : getCrewAssessmentByDutyNoAndDay,
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			getNewCrewAssessment : getNewCrewAssessment,
			getTempAssessment : getTempAssessment,
			saveTempAssessment : saveTempAssessment,
			clearTempAssessment : clearTempAssessment,
			updateCrewMembers : updateCrewMembers,
			updateCrewAssessment : updateCrewAssessment,
			getAssesedCabinReports : getAssesedCabinReports,
			existsForRouteDutyDate : existsForRouteDutyDate,
			getAssementsReadyToSend : getAssementsReadyToSend,
			storeFlightsWithAssessments : storeFlightsWithAssessments,
			updateFlightsAssessment : updateFlightsAssessment,
            updateAssessmentFlights : updateAssessmentFlights,

			updateAndMergeAllFaAssessments: updateAndMergeAllFaAssessments,
			getFaMembersForFeedback: getFaMembersForFeedback,
			hasSyncedFeedbacks: hasSyncedFeedbacks
		};
		
		//object functions
        /**
         * Overide default get Id
         * @memberof CrewAssessmentFactory
         * @returns {number} Id 
         */
		function GetId(){
			return this.Id;
		}

		//factory functions
         /**
         * Get Crew Assessments
         * @memberof CrewAssessmentFactory
         * @returns {Array} crewAssesments 
         */
		function getCrewAssessmentsFromStorage() {
            var lsItems = GenericService.list(objType,objCallback);
            var items = [];
            for (var i = 0; i < lsItems.length; i++) {
				if (lsItems[i]) {
					items.push(lsItems[i]);
				}
			}
			return items;
		}

        /**
         * Save Crew Assessments to storage
         * @memberof CrewAssessmentFactory
         * @param {Array} crewAssessments A list of Cabin Crew Feedbacks
         */
		function setCrewAssessmentsToStorage(crewAssessments) {
			GenericService.saveAll(crewAssessments,objType,objCallback);
		}

        /**
         * Save one Crew Assessment to storage
         * @memberof CrewAssessmentFactory
         * @param {Object} crewAssessment A Cabin Crew Feedback
         */
		function setCrewAssessmentToStorage(crewAssessment) {
			GenericService.save(crewAssessment,objType,objCallback);
		}

        /**
         * Get a Crew Assessment from storage
         * @memberof CrewAssessmentFactory
         * @param {number} crewAssessmentId  the Id of the selected Crew Assessment
         * @returns {Object} crewAssesment
         */
		function getCrewAssessmentFromStorage(crewAssessmentId) {
			return GenericService.get(crewAssessmentId,objType,objCallback);
		}

        /**
         * Get Count of Uncompleted Assessments 
         * @memberof CrewAssessmentFactory
         * @returns {number} count
         */
		function getCountOfUncompletedAssessments() {
			var crewAssessments = getCrewAssessmentsFromStorage();
			var count = 0;
			if (crewAssessments == null)
				return 0;

			for (var i = 0; i < crewAssessments.length; i++) {
				if (!crewAssessments[i].IsExist && crewAssessments[i].Status != "Completed") {
					count++;
				}
			}
			return count;
		};



        /**
         * Extend Object from the default CrewAssessment Object
         * @memberof CrewAssessmentFactory
         * @param {Object} obj  a crewAssesment
         * @returns {Object} crewAssesment
         */
		function fromObject (obj){
			return GenericService.fromObject(obj,objCallback);
		}

        /**
         * Extend an array of Objects from the default CrewAssessment Object
         * @memberof CrewAssessmentFactory
         * @param {Array} objList  an Array Of crewAssesments
         * @returns {Array} crewAssesments
         */
		function fromObjectList (objList){
			return GenericService.fromObjectList(objList,objCallback);
		}

        /**
         * Initialize a new Crew Assessment from the default Constructor
         * @memberof CrewAssessmentFactory
         * @returns {Object} crewAssesment
         */
		function getNewCrewAssessment() {
			return GenericService.constructor(objCallback);
		};

    
        /**
         * Get the Temporary Assessment from the local storage
         * @memberof CrewAssessmentFactory
         * @returns {Object} crewAssesment
         */
		function getTempAssessment() {
			var crewAssessmentLocalEdit = localStorageMD5Service.get('crewAssessmentLocalEdit_TEMP');
			return fromObject(crewAssessmentLocalEdit);
		};

        /**
         * Save the Temporary Assessment to  the local storage
         * @memberof CrewAssessmentFactory
         * @param {Object} assessment  a crewAssesment
         * @param {number} FlightId  a crewAssesment
         */
		function saveTempAssessment(assessment,FlightId) {
            if (assessment){
                assessment.FlightId = FlightId;
                localStorageMD5Service.remove('crewAssessmentLocalEdit_TEMP');
                localStorageMD5Service.set('crewAssessmentLocalEdit_TEMP', assessment);
            }
		};

        /**
         * Remove the Temporary Assessment of  the local storage
         * @memberof CrewAssessmentFactory
         */
		function clearTempAssessment() {
			localStorageMD5Service.remove('crewAssessmentLocalEdit_TEMP');
		};

		/**
		 * Update and merge all FA assessments
		 * @memberof CrewAssessmentFactory
		 * @param {Array} assessments  an array of crew assessments
		 */
		function updateAndMergeAllFaAssessments(newFaAssessments) {
			var oldFaAssessments = getCrewAssessmentsFromStorage() || [];
			newFaAssessments = newFaAssessments || [];
			var finalFaAssessments = [];
			var assessmentsToCreate = [];

			// group old by Route+DutyDate
			var oldGroups = {};
			oldFaAssessments.forEach(item => {
				var key = item.Route + "|" + item.DutyDate;
				if (!oldGroups[key]) oldGroups[key] = [];
				oldGroups[key].push(item);
			});

			// group new by Route+DutyDate
			var newGroups = {};
			newFaAssessments.forEach(item => {
				var key = item.Route + "|" + item.DutyDate;
				if (!newGroups[key]) newGroups[key] = [];
				newGroups[key].push(item);
			});

			// process each new group
			for (var key in newGroups) {
				var newGroup = newGroups[key];
				var oldGroup = oldGroups[key] || [];

				if (newGroup.length === oldGroup.length && newGroup.length > 0) {
					// counts equal → update one by one, matched by FeedbackDate
					newGroup.forEach(n => {
						// find matching old by FeedbackDate 
						var match = oldGroup.find(o =>
							o.FeedbackDate === n.FeedbackDate 
							//|| (!o.FeedbackDate && !n.FeedbackDate) //(null/undefined allowed to match empty)
						);

						if (match) {
							var updated = updateCrewAssessment(match, n);
							finalFaAssessments.push(updated);
						} else {
							// no match → treat as new
							assessmentsToCreate.push(n);
						}
					});
				} else {
					// counts differ → ignore olds, just create all news
					assessmentsToCreate = assessmentsToCreate.concat(newGroup);
				}
			}

			// create new assessments
			var created = createCrewAssessments(assessmentsToCreate);
			finalFaAssessments = finalFaAssessments.concat(created);

			// replace storage with only updated + created
			setCrewAssessmentsToStorage(finalFaAssessments);
			storeFlightsWithAssessments();
		}

        /**
         * Update CrewMembers of the assessment based on CCMSPositions
         * @memberof CrewAssessmentFactory
         * @param {string} CCMSPositions  the ccms Position of the Flight
         * @param {string} Route  The route of the assessment
         * @param {string} DutyDate  The duty date of the assessment
         */
		function updateCrewMembers(CCMSPositions, Route, DutyDate, flightDate) {
			var assessment = getCrewAssessmentByRouteAndDay(Route, DutyDate, flightDate);
			var crewAssessmentTemplate = CrewAssessmentTemplateFactory.getCrewAssessmentTemplateFromStorage();
			var routeFlights = FlightFactory.getFlightsByRoutePerDay(Route, DutyDate, flightDate);
			var isChanged = false;

			if (CCMSPositions != null && assessment != null) {

				for (var i = 0; i < CCMSPositions.length; i++) {
					var isExists = false;

					for (var j = 0; j < assessment.CrewAssessmentMembers.length; j++) {
						if (CCMSPositions[i].CrewId == assessment.CrewAssessmentMembers[j].aimsId) {
							isExists = true;

							if (CCMSPositions[i].CCMS == "N/A") {
								var isValid = false;

								for (var h = 0; h < routeFlights.length; h++) {
									var localReport = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(routeFlights[h].FlightId);

									if (localReport != null) {
										for (var e = 0; e < localReport.CCMSCrewPositions.length; e++) {
											if (CCMSPositions[i].CrewId == localReport.CCMSCrewPositions[e].CrewId && localReport.CCMSCrewPositions[e].CCMS != "N/A") {
												isValid = true;
												break;
											}
										}
									}
									if (isValid) {
										break;
									}
								}
								if (assessment.CrewAssessmentMembers[j].IsValid != isValid) {
									isChanged = true;
								}
								assessment.CrewAssessmentMembers[j].IsValid = isValid;
							} else {
								if (!assessment.CrewAssessmentMembers[j].IsValid) {
									isChanged = true;
								}
								assessment.CrewAssessmentMembers[j].IsValid = true;
							}
						}
					}

					if (!isExists && CCMSPositions[i].IsManual) {
						var crewMember = CrewAssessmentMemberFactory.newMember();
						crewMember.aimsId = CCMSPositions[i].CrewId;
						crewMember.assessmentItems = crewAssessmentTemplate
						crewMember.name = CCMSPositions[i].Name;
						crewMember.position = CCMSPositions[i].Position;
						crewMember.shortname = CCMSPositions[i].Initials;
						crewMember.IsManual = true;
						crewMember.IsCompleted = false;
						crewMember.IsValid = (CCMSPositions[i].CCMS != "N/A");
						isChanged = true;
						assessment.CrewAssessmentMembers.push(crewMember);
					}
				}

				for (var i = 0; i < assessment.CrewAssessmentMembers.length; i++) {
					for (var h = 0; h < routeFlights.length; h++) {
						var localReport = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(routeFlights[h].FlightId);

						if (localReport != null) {
							isExists = false;

							for (var j = 0; j < localReport.CCMSCrewPositions.length; j++) {
								if (localReport.CCMSCrewPositions[j].CrewId == assessment.CrewAssessmentMembers[i].aimsId) {
									isExists = true;
									break;
								}
							}
						}
					}
					if (!isExists) {
						if (assessment.CrewAssessmentMembers[i].IsValid) {
							isChanged = true;
						}
						assessment.CrewAssessmentMembers[i].IsValid = false;
					}
				}
				if (isChanged && assessment.Status != "Pending") {
					assessment.Status = "Draft";
					var flights = FlightFactory.getFlightsFromStorage();

					for (var i = 0; i < flights.length; i++) {
						if (flights[i].assessment && flights[i].assessment.Id == assessment.Id) {
							flights[i].assessment.Status = assessment.Status;
						}
					}
					FlightFactory.setFlightsToStorage(flights);
				}
			 setCrewAssessmentToStorage(assessment);
			}
		}

        /**
         * Update Assessment from the new Assessment from Sync
         * @memberof CrewAssessmentFactory
         * @param {Object} assessment  The assessment
         * @param {Object} newAssessment  The new assessment
         */		
		function updateCrewAssessment(assessment, newAssessment) {
			var crewAssessmentTemplate = CrewAssessmentTemplateFactory.getCrewAssessmentTemplateFromStorage();
			if (crewAssessmentTemplate == null) return assessment;
		
			// Load the flight
			var flights = FlightFactory.getFlightsByRoutePerDay(assessment.Route, assessment.DutyDate, newAssessment.FeedbackDate);
			if (flights == null) return assessment;
		
			assessment.Flights = [];
			assessment.AcType = flights[0].AcType;
			assessment = updateAssessmentFlights(assessment, flights);
			assessment.FeedbackDate = newAssessment.FeedbackDate;

			var isUpdated = false;
	
			// Flags to check member states
			var validCrewCount = 0;         // Non-outdated and exists
			var outdatedCrewCount = 0;      // Outdated
			var nonExistentCrewCount = 0;   // Non-outdated but doesn't exist
		
			//filter by feedback date
			newAssessment.assessmentCrew = crewAssessmentFilteredByFeedbackDate(newAssessment);
			//filter by common flights in the route
			var flightIds = flights.map(f => f.FlightId);
			newAssessment.assessmentCrew = filterCrewAssessmentMembersByCommonFlightsInRoute(newAssessment.assessmentCrew, flightIds);


			for (var i = 0; i < newAssessment.assessmentCrew.length; i++) {
				var isCreated = false;

				// Update flags based on crew member status
				if (newAssessment.assessmentCrew[i].IsOutdated && !newAssessment.assessmentCrew[i].IsExist) {
					outdatedCrewCount++;
				} else if (!newAssessment.assessmentCrew[i].IsExist) {
					nonExistentCrewCount++;
				} else {
					validCrewCount++;
				}
		
				for (var l = 0; l < assessment.CrewAssessmentMembers.length; l++) {
					if (newAssessment.assessmentCrew[i].CrewAimsId == assessment.CrewAssessmentMembers[l].aimsId ||
						newAssessment.assessmentCrew[i].CrewId == assessment.CrewAssessmentMembers[l].Id) {
		
						assessment.CrewAssessmentMembers[l].aimsId = newAssessment.assessmentCrew[i].CrewAimsId;
						assessment.CrewAssessmentMembers[l].id = newAssessment.assessmentCrew[i].CrewId;
						assessment.CrewAssessmentMembers[l].name = newAssessment.assessmentCrew[i].Name;
						assessment.CrewAssessmentMembers[l].IsValid = true;
						assessment.CrewAssessmentMembers[l].IsOutdated = newAssessment.assessmentCrew[i].IsOutdated;
						assessment.CrewAssessmentMembers[l].EndPeriod = newAssessment.assessmentCrew[i].EndPeriod;

						var newAssessmentItems = [];
		
						for (var j = 0; j < crewAssessmentTemplate.length; j++) {
							var question = {
								Id: crewAssessmentTemplate[j].Id,
								Description: crewAssessmentTemplate[j].Description,
								Label: crewAssessmentTemplate[j].Label,
								OrderNo: crewAssessmentTemplate[j].OrderNo,
								ItemValue: crewAssessmentTemplate[j].ItemValue,
								ItemDescr: null
							}
							if (assessment.CrewAssessmentMembers[l].assessmentItems) {
								for (var h = 0; h < assessment.CrewAssessmentMembers[l].assessmentItems.length; h++) {
									if (crewAssessmentTemplate[j].Id == assessment.CrewAssessmentMembers[l].assessmentItems[h].Id) {
										question.ItemValue = assessment.CrewAssessmentMembers[l].assessmentItems[h].ItemValue;
										question.ItemDescr = assessment.CrewAssessmentMembers[l].assessmentItems[h].ItemDescr;
									}
								}
							}
							newAssessmentItems.push(question);
						}
						assessment.CrewAssessmentMembers[l].assessmentItems = newAssessmentItems;
		
						if (assessment.CrewAssessmentMembers[l].IsExist != newAssessment.assessmentCrew[i].IsExist) {
							assessment.CrewAssessmentMembers[l].IsExist = newAssessment.assessmentCrew[i].IsExist;
							isUpdated = true;
						}
						isCreated = true;
						break;
					}
				}
				if (!isCreated) {
					var crewMember = CrewAssessmentMemberFactory.newMember();
					crewMember.aimsId = newAssessment.assessmentCrew[i].CrewAimsId;
					crewMember.id = newAssessment.assessmentCrew[i].CrewId;
					crewMember.assessmentItems = crewAssessmentTemplate;
					crewMember.name = newAssessment.assessmentCrew[i].Name;
					crewMember.IsCompleted = false;
					crewMember.IsValid = true;
					crewMember.IsExist = newAssessment.assessmentCrew[i].IsExist;
					crewMember.IsOutdated = newAssessment.assessmentCrew[i].IsOutdated;
					crewMember.EndPeriod = newAssessment.assessmentCrew[i].EndPeriod;
			
					assessment.CrewAssessmentMembers.push(crewMember);
					isUpdated = true;
				}
			}
		
			for (var l = 0; l < assessment.CrewAssessmentMembers.length; l++) {
				var isExists = false;
				for (var i = 0; i < newAssessment.assessmentCrew.length; i++) {
					if (newAssessment.assessmentCrew[i].CrewAimsId == assessment.CrewAssessmentMembers[l].aimsId ||
						newAssessment.assessmentCrew[i].CrewId == assessment.CrewAssessmentMembers[l].Id) {
						isExists = true;
						break;
					}
				}
				if (!isExists && !assessment.CrewAssessmentMembers[l].IsManual) {
					assessment.CrewAssessmentMembers.splice(l, 1);
					l--; // Adjust index after removal
					isUpdated = true;
				}
			}

			// Update the Status based on the flags
			if (validCrewCount > 0) {
				// If there's at least one valid (non-outdated and existing) crew member
				assessment.Status = "Stored";
			} else if (outdatedCrewCount > 0 && nonExistentCrewCount === 0) {
				// All members are outdated
				assessment.Status = "Outdated";
			} else if (nonExistentCrewCount > 0) {
				// If there are non-outdated but non-existent members
				assessment.Status = "Pending";
			} else if (isUpdated && assessment.Status == "Stored") {
				// If there were updates and it was stored before, downgrade to Draft
				assessment.Status = "Draft";
			}
		
			assessment.assessedBy = newAssessment.assessedBy;
		
			// Update IsExist based on the flag
			assessment.IsExist = validCrewCount > 0;
		
			return assessment;
		}
			


        /**
         * Get only the reports that have a stored or complete Assessment
         * @memberof CrewAssessmentFactory
         * @returns {Array} crewAssesments 
         */
		function getAssesedCabinReports() { 
			var reports = CabinReportLocalEditFactory.getCabinReportsFromStorage();
			var assessments = getCrewAssessmentsFromStorage();

			var assesedReports = [];

			for (var i = 0; i < assessments.length; i++) {
				if (assessments[i].Status != "Completed" && !assessments[i].IsExist && assessments[i].CrewAssessmentMembers.length > 0) {
					var isCompleted = true;
					var routeReports = [];
					for (var j = 0; j < reports.length; j++) {
						if (reports[j].Route == assessments[i].Route && reports[j].DutyDate == assessments[i].DutyDate) {
							if (reports[j].Status != "completed") {
								isCompleted = false;
							} else {
								routeReports.push(reports[j]);
							}
						}
					}
					if (isCompleted) {
						var flights = FlightFactory.getFlightsByRoutePerDay(assessments[i].Route, assessments[i].DutyDate, assessments[i].FeedbackDate);
						for (var j = 0; j < flights.length; j++) {
							if (flights[j].cabinReportStatusDescr == "Pending") {
								isCompleted = false
								break;
							}

						}
					}
					if (!isCompleted) {
						assesedReports = assesedReports.concat(routeReports);
					} else if (routeReports != []) {
						routeReports.sort(function(a, b) {
							return (new Date(b.ScheduledDeparture) - new Date(a.ScheduledDeparture))
						});
						routeReports.splice(0, 1);
						assesedReports = assesedReports.concat(routeReports);
					}

				} else {
					for (var j = 0; j < reports.length; j++) {
						if (reports[j].Route == assessments[i].Route && reports[j].DutyDate == assessments[i].DutyDate) {
							if (reports[j].Status == "completed") {
								assesedReports.push(reports[j]);
							}
						}
					}
				}
			}

			//orphaned reports
			for (var j = 0; j < reports.length; j++) {
				if (!existsForRouteDutyDate(reports[j].Route, reports[j].DutyDate, reports[j].FeedbackDate)) {
					if (reports[j].Status == "completed") {
						assesedReports.push(reports[j]);
					}
				}
			}
			return assesedReports;
			}

        /**
         * Find if an assessment exists for the selected Route and Duty Date
         * @memberof CrewAssessmentFactory
         * @param {string} Route  The route of the assessment
         * @param {string} DutyDate  The duty date of the assessment
         * @returns {boolean} isExist 
         */
		function existsForRouteDutyDate(Route, DutyDate, FeedbackDate) {
			var assessments = getCrewAssessmentsFromStorage();
			var isExist = false;
			for (var j = 0; j < assessments.length; j++) {
				if (assessments[j].Route == Route && assessments[j].DutyDate == DutyDate && 
					(!assessments[j].FeedbackDate || assessments[j].FeedbackDate == FeedbackDate)) {
					isExist = true;
					break;
				}
			}
			return isExist;
		}

        /**
         * Update Assessment Information from flights
         * @memberof CrewAssessmentFactory
         * @param {Object} crewAssessment  The crew assessment
         * @param {Array} flights  The flights of the Assessment
         */
        function updateAssessmentFlights(crewAssessment,flights){
			for (var i = 0; i < flights.length; i++) {
                if(crewAssessment.start && crewAssessment.end){
                    var flightStart = Date.parse(flights[i].ScheduledDeparture);
                    var flightEnd = Date.parse(flights[i].ScheduledArrival);
 
                    var assesmentStart = Date.parse(crewAssessment.start);
                    if (flightStart<assesmentStart){
                         crewAssessment.start = flights[i].ScheduledDeparture;
                    }
                    else{
                        var assesmentEnd = Date.parse(crewAssessment.end);
                        if (flightEnd>assesmentEnd){
                            crewAssessment.end = flights[i].ScheduledArrival;
                        }  
                    }
                }else{
                    crewAssessment.start = flights[i].ScheduledDeparture;
                    crewAssessment.end = flights[i].ScheduledArrival;
                }
                
				var flight = {
					FlightId: flights[i].FlightId,
					ScheduledDepartureDateUTC: flights[i].ScheduledDepartureDateUTC,
					FlightNo: flights[i].FlightNo,
					Departure: flights[i].Departure,
					Arrival: flights[i].Arrival,
					ScheduledDepartureTimeUTC: flights[i].ScheduledDepartureTimeUTC,
                    ScheduledDeparture: flights[i].ScheduledDeparture,
					ScheduledArrival: flights[i].ScheduledArrival,
					AcTailNo: flights[i].AcTailNo,
					DutyDate: flights[i].DutyDate
				}
				crewAssessment.Flights.push(flight);
			}
            
            return crewAssessment;
        }
    
        /**
         * Returns the a list of cabin Crew Feedbacks that are ready to send (the reports of the assessment are completed or synched)
         * @memberof CrewAssessmentFactory
         * @param {string} Route  The route of the assessment
         * @param {string} DutyDate  The duty date of the assessment
         * @returns {Array} assessmentsToSend  
         */
		function getAssementsReadyToSend() {
			var assessments = getCrewAssessmentsFromStorage();
			var assessmentsToSend = [];
			for (var i = 0; i < assessments.length; i++) {
				if (assessments[i].Status == "Completed") {

					assessmentsToSend.push(assessments[i]);
					
					////Send assessments anyway...
					// var isCompleted = true;
					// var flights = FlightFactory.getFlightsByRoute(assessments[i].Route, assessments[i].DutyDate);
					// for (var j = 0; j < flights.length; j++) {
					// 	if (flights[j].LineStatus == "pending" || flights[j].LineStatus == "pendingoverdue" || flights[j].LineStatus == "draft") {
					// 		isCompleted = false;
					// 		break;
					// 	}
					// }
					// if (isCompleted) {
					// 	assessmentsToSend.push(assessments[i])
					// }
				}

			}
			return assessmentsToSend;
		}

        /**
         * Store Assessment inside the flights
         * @memberof CrewAssessmentFactory
         */
		function storeFlightsWithAssessments() {
			var flights = FlightFactory.getFlightsFromStorage();
			var crewAssessments = getCrewAssessmentsFromStorage();
			for (var i = 0; i < flights.length; i++) {
				for (var j = 0; j < crewAssessments.length; j++) {
					if (flights[i].Route == crewAssessments[j].Route 
							&& ( (crewAssessments[j].FeedbackDate && flights[i].FlightDate == crewAssessments[j].FeedbackDate)
								|| (!crewAssessments[j].FeedbackDate && flights[i].DutyDate == crewAssessments[j].DutyDate))
							) {
						flights[i].assessment = {
							Id: crewAssessments[j].Id,
							Status: crewAssessments[j].Status,
							IsExist: crewAssessments[j].IsExist,
							IsAssessedBy: crewAssessments[j].assessedBy.length > 0,
							IsCrewLess: crewAssessments[j].CrewAssessmentMembers.length < 1,
							FeedbackDate: crewAssessments[j].FeedbackDate
						}
						break;
					}
				}
			}
			FlightFactory.setFlightsToStorage(flights);
		}

        /**
         * Update Assessments which are stored inside the flights 
         * @memberof CrewAssessmentFactory
         * @param {Object} crewAssessment  The crew assessment\
         */
		function updateFlightsAssessment(assessment) {
			var flights = FlightFactory.getFlightsFromStorage();
			for (var i = 0; i < flights.length; i++) {
				//TODO:: if assessment.Id =0 ? then route + dutyDate + feedbackdate
				if (flights[i].assessment && flights[i].assessment.Id == assessment.Id) {
					flights[i].assessment.Status = assessment.Status;
				}
			}
			FlightFactory.setFlightsToStorage(flights);
		}

		 /**
         * Create New Crew Assessments from the api assessments
         * @memberof CrewAssessmentFactory
         * @returns {Array} crewAssessments 
         */
		function createCrewAssessments(assessments) {
			var crewAssessments = [];
			for (var i = 0; i < assessments.length; i++) {
				var crewAssessment = createNewCrewAssessment(assessments[i])
                if(crewAssessment){
                   crewAssessments.push(crewAssessment);
                }
				
			}
			return crewAssessments;
		}

		 /**
         * Create New Crew Assessment from the api assessments
         * @memberof CrewAssessmentFactory
         * @returns {object} assessment 
         */
		function createNewCrewAssessment(assessment) {
			// load the user
			var user = UserFactory.getUser();
			if (user == null)
				return null;

			// load the crewAssessmentTemplate
			var crewAssessmentTemplates = CrewAssessmentTemplateFactory.getCrewAssessmentTemplateFromStorage();
			if (crewAssessmentTemplates == null)
				return null;

			// load the flight
			var flights = FlightFactory.getFlightsByRoutePerDay(assessment.Route, assessment.DutyDate, assessment.FeedbackDate);
			if (flights == null || flights.length==0)
				return null;


			// create the new crewAssessment
			var crewAssessment = getNewCrewAssessment();

			crewAssessment.Id = (assessment.Id == null) ? guid() : assessment.Id;
			crewAssessment.UserId = user.id;
			crewAssessment.Route = assessment.Route;
			crewAssessment.DutyDate = assessment.DutyDate;
			crewAssessment.DutyDay = assessment.DutyDay;
            crewAssessment.AcType = flights[0].AcType;
			crewAssessment = updateAssessmentFlights(crewAssessment,flights);

			crewAssessment.assessedBy = assessment.assessedBy;
			crewAssessment.FeedbackDate = assessment.FeedbackDate;
			var IsExist = true;

			//filter by feedback date
			assessment.assessmentCrew = crewAssessmentFilteredByFeedbackDate(assessment);
			//filter by common flights in the route
			var flightIds = flights.map(f => f.FlightId);
			// Filter the CrewAssessmentMembers to include only those with common flights in the route
            assessment.assessmentCrew = filterCrewAssessmentMembersByCommonFlightsInRoute(assessment.assessmentCrew, flightIds);
 
			//add crew members
			for (var i = 0; i < assessment.assessmentCrew.length; i++) {
				//check for double crew members
				if(crewAssessment.CrewAssessmentMembers 
					&& !crewAssessment.CrewAssessmentMembers.some(member => member.aimsId === assessment.assessmentCrew[i].CrewAimsId) ) {
					var crewMember = CrewAssessmentMemberFactory.newMember();
					crewMember.aimsId = assessment.assessmentCrew[i].CrewAimsId;
					crewMember.id = assessment.assessmentCrew[i].CrewId;
					crewMember.assessmentItems = crewAssessmentTemplates;
					crewMember.name = assessment.assessmentCrew[i].Name;
					crewMember.IsCompleted = false;
					crewMember.IsValid = true;
					crewMember.IsExist = assessment.assessmentCrew[i].IsExist;
					crewMember.IsOutdated = assessment.assessmentCrew[i].IsOutdated;
					crewMember.EndPeriod = assessment.assessmentCrew[i].EndPeriod;

					if (!assessment.assessmentCrew[i].IsExist) {
						IsExist = false;
					}

					crewAssessment.CrewAssessmentMembers.push(crewMember);
				}

				
			}

			crewAssessment.IsExist = IsExist;
			if(IsExist){
				crewAssessment.Status = "Stored";
			}
			// return the new crewAssessment
			return crewAssessment;
		}

       function getFaMembersForFeedback(faMembersIdsInRoute, crewAssessmentInLS) {
            // Check if faMembersIdsInRoute or crewAssessmentInLS is not defined/null
            if (!faMembersIdsInRoute || !crewAssessmentInLS ) {
                console.error("empty crewAssessmentInLS or faMembersIdsInRoute");
                return [];
            }

            // Get the current date + 1 day
            var nowPlusOne = new Date();
            nowPlusOne.setDate(nowPlusOne.getDate() + 1);

            if(defaultCalendarDate){
                nowPlusOne = new Date(defaultCalendarDate);
            }

            const commonFaMembers = crewAssessmentInLS.CrewAssessmentMembers.filter(member => {
                const memberEndDate = new Date(member.EndPeriod);
        
                // Check if the member's ID matches and the endDate is valid
                return (
                    faMembersIdsInRoute.includes(member.aimsId) 
					
					//Temporarily disabled the end date check
                    // && memberEndDate >= nowPlusOne // End date is greater than or equal to now + 1
                );
            });

            return commonFaMembers;
        }

		/*
		* Get Crew Assessment By duty number and Day
		* @memberof CrewAssessmentFactory
		* @param {string} dutyNo  the Duty Number of the desired Crew Assessment
		* @param {string} dutyDay  the Duty Day of the desired Crew Assessment
		* @param {string} feedbackDate  the Feedback Date of the desired Crew Assessment
		* @returns {Object} crewAssessment
		*/
		function getCrewAssessmentByDutyNoAndDay(dutyNo, dutyDay, feedbackDate) {
			var crewAssessments = getCrewAssessmentsFromStorage();
			if (crewAssessments == null || dutyNo == null || dutyDay == null)
				return null;

			var result = null;

			var arrayLength = crewAssessments.length;
			for (var i = 0; i < arrayLength; i++) {
				if (crewAssessments[i].DutyNo == dutyNo && crewAssessments[i].DutyDay == dutyDay && 
					(!crewAssessments[i].FeedbackDate || crewAssessments[i].FeedbackDate == feedbackDate )) {
					result = crewAssessments[i];
					break;
				}
			}
			return result;
		}
		/**
		* Get Crew Assessment By Route and Day
		* @memberof CrewAssessmentFactory
		* @param {string} route  the Route of the desired Crew Assessment
		* @param {string} dutyDay  the Duty Day of the desired Crew Assessment
		* @param {string} feedbackDate  the Feedback Date of the desired Crew Assessment
		* @returns {Object} crewAssessment
		*/
		function getCrewAssessmentByRouteAndDay(route, dutyDay, feedbackDate) {
			var crewAssessments = getCrewAssessmentsFromStorage();
			if (crewAssessments == null || route == null || dutyDay == null)
				return null;

			var result = null;

			var arrayLength = crewAssessments.length;
			for (var i = 0; i < arrayLength; i++) {
				if (crewAssessments[i].Route == route && crewAssessments[i].DutyDay == dutyDay && 
					(!crewAssessments[i].FeedbackDate || crewAssessments[i].FeedbackDate == feedbackDate )) {
					result = crewAssessments[i];
					break;
				}
			}
			return result;
		}

		function hasSyncedFeedbacks(route, dutyDay, feedbackDate){
            var isSynced = false;
            var crewAssessments = getCrewAssessmentsFromStorage();
            if(crewAssessments && crewAssessments.length > 0){
                var storedFeedback = crewAssessments.find(f => f.Route == route && f.DutyDay == dutyDay && 
                   (!f.FeedbackDate || f.FeedbackDate == feedbackDate));
                
                if(storedFeedback && storedFeedback.IsExist){
                    isSynced = true;
                }
            }
            return isSynced;
        }

		// Filters the assessmentCrew to include only those matching the FeedbackDate (if any)
		function crewAssessmentFilteredByFeedbackDate(assessment){
			var filteredCrew = [];
			if (assessment && assessment.assessmentCrew && assessment.assessmentCrew.length > 0){
				for (var i = 0; i < assessment.assessmentCrew.length; i++) {
					if (!assessment.FeedbackDate || assessment.FeedbackDate == assessment.assessmentCrew[i].FlightDate){
						filteredCrew.push(assessment.assessmentCrew[i]);
					}
				}
			}
			return filteredCrew;
		}

		// Filters the CrewAssessmentMembers to include only those with common flights in the route
        function filterCrewAssessmentMembersByCommonFlightsInRoute(members, flightIdsInRoute) {
			if (!members || members.length === 0 || !flightIdsInRoute || flightIdsInRoute.length === 0) {
				return [];
			}
			var commonFlightsWithFA = localStorageMD5Service.get('CommonFlightsWithFA') || [];
            const faAimsIds = commonFlightsWithFA
                                .filter(entry =>
                                    entry.Flights.some(flight => flightIdsInRoute.includes(flight.FlightId))
                                )
                                .map(entry => entry.FaAimsId);
            return members.filter(member => faAimsIds.includes(member.CrewAimsId));
        }

	return service;
	}
    
})();